import request from '@/utils/request'
// 员工新增
export function addPerson(data) {
  return request({
    url: '/bs-person/save',
    method: 'post',
    data
  })
}
// 员工详情
export function personDetail(id) {
  return request({
    url: `/bs-person/get/${id}`,
    method: 'get',
  })
}
// 员工修改
export function editPerson(data) {
  return request({
    url: '/bs-person/update',
    method: 'put',
    data
  })
}
// 员工删除
export function delPerson(id) {
  return request({
    url: '/bs-person/remove/' + id,
    method: 'delete'
  })
}
// 合同明细
export function delContractDetail(id) {
  return request({
    url: '/bs-person/removeContractDetailed/' + id,
    method: 'delete'
  })
}
// 证书明细
export function delCredentials(id) {
  return request({
    url: '/bs-person/removeCredentialsDetailed/' + id,
    method: 'delete'
  })
}
// 薪资明细
export function delSalary(id) {
  return request({
    url: '/bs-person/removeSalary/' + id,
    method: 'delete'
  })
}
// 技能明细
export function delSkill(id) {
  return request({
    url: '/bs-person/removeSkillsContent/' + id,
    method: 'delete'
  })
}
// 关键输出物新增
export function addOutput(data) {
  return request({
    url: '/bsKeyOuts',
    method: 'post',
    data
  })
}
export function editOutput(data) {
  return request({
    url: '/bsKeyOuts',
    method: 'put',
    data
  })
}
export function delOutput(id) {
  return request({
    url: '/bsKeyOuts/' + id,
    method: 'delete'
  })
}
// 立项(销售)
export function addSellProject(data) {
  return request({
    url: '/sellProject',
    method: 'post',
    data
  })
}
export function sellProjectDetail(id) {
  return request({
    url: `/sellProject/${id}`,
    method: 'get',
  })
}
export function editSellProject(data) {
  return request({
    url: '/sellProject',
    method: 'put',
    data
  })
}
export function delSellProjects(id) {
  return request({
    url: '/sellProject/' + id,
    method: 'delete'
  })
}
// 单个删除人工成本明细
export function delSellBizArtificial(id) {
  return request({
    url: '/sellProject/deleteArtificialCost/' + id,
    method: 'delete'
  })
}
// 单个删除奖金分配方案
export function delSellBonusScheme(id) {
  return request({
    url: '/sellProject/deleteBonusScheme/' + id,
    method: 'delete'
  })
}
// 单个删除费用明细
export function delSellCostBudget(id) {
  return request({
    url: '/sellProject/deleteCostDetail/' + id,
    method: 'delete'
  })
}
// 删除多个
export function delSellProject() {
  return request({
    url: '/sellProject/',
    method: 'delete'
  })
}
// 商机
export function addBusiess(data) {
  return request({
    url: '/business',
    method: 'post',
    data
  })
}
export function busiessDetail(id) {
  return request({
    url: `/business/${id}`,
    method: 'get',
  })
}
export function editBusiess(data) {
  return request({
    url: '/business/',
    method: 'put',
    data
  })
}
export function delBusiess(id) {
  return request({
    url: '/business/' + id,
    method: 'delete'
  })
}
// 单个删除竞争对手
export function delBusiessCompetitor(id) {
  return request({
    url: '/business/competitor/' + id,
    method: 'delete'
  })
}
// 单个删除客户信息
export function delBusiessCustomer(id) {
  return request({
    url: '/business/customer/' + id,
    method: 'delete'
  })
}
// 单个删除售前预估
export function delBusiessEstimate(id) {
  return request({
    url: '/business/saleEstimate/' + id,
    method: 'delete'
  })
}
// 立项交付
export function addProjectDelivery(data) {
  return request({
    url: '/projectDelivery',
    method: 'post',
    data
  })
}

export function changeProjectDelivery(data) {
  return request({
    url: '/projectDelivery/change',
    method: 'post',
    data
  })
}
export function getProjectDelivery(id) {
  return request({
    url: `/projectDelivery/${id}`,
    method: 'get',
  })
}
export function editProjectDelivery(data) {
  return request({
    url: '/projectDelivery/',
    method: 'put',
    data
  })
}
export function delProjectDelivery(id) {
  return request({
    url: '/projectDelivery/' + id,
    method: 'delete'
  })
}

// 关闭立项
export function closeProjectDelivery(id) {
  return request({
    url: `/projectDelivery/close/${id}`,
    method: 'put',
  })
}
// 单个删除项目奖金
export function delBonuses(id) {
  return request({
    url: '/projectDelivery/bonuses/' + id,
    method: 'delete'
  })
}
// 单个删除奖金分配方案
export function delBonusPlans(id) {
  return request({
    url: '/projectDelivery/bonusPlans/' + id,
    method: 'delete'
  })
}
// 单个费用明细
export function delChargeDetails(id) {
  return request({
    url: '/projectDelivery/chargeDetails/' + id,
    method: 'delete'
  })
}
// 单个可支配人员
export function delDisposablePeople(id) {
  return request({
    url: '/projectDelivery/disposablePersons/' + id,
    method: 'delete'
  })
}
// 单个删除人工成本
export function delLaborCosts(id) {
  return request({
    url: '/projectDelivery/laborCosts/' + id,
    method: 'delete'
  })
}
// 单个删除里程碑计划单
export function delMilestonePlans(id) {
  return request({
    url: '/projectDelivery/milestonePlans/' + id,
    method: 'delete'
  })
}
export function deliveryIsFinish(id,isFinish) {
  return request({
    url: `/projectDelivery/milestonePlans/${id}/${isFinish}`,
    method: 'put',
  })
}

export function deliveryMilestoneStatus(id,status) {
  return request({
    url: `/projectDelivery/milestonePlans/status/${id}/${status}`,
    method: 'put',
  })
}
// 提交附件审批
/*  export function submitFile(data) {
  return request({
    url: '/projectDelivery/submitFile',
    method: 'post',
    data
  })
} */
export function submitFile(data) {
  return request({
    url: '/projectDelivery/submitFile',
    method: 'post',
    data
  })
}

